import type { InvoiceFilterSchema } from './filter-schema';

export const filterDefaultValues: Readonly<InvoiceFilterSchema> = {
  brand: null,
  partner: null,
  invoice_number: '',
  invoice_date: '',
  // billing_period_start_date: '',
  // billing_period_end_date: '',
  due_date: '',
  status: null,
  execution_status: null,
  client: null,
  latest_email_history: null,
} as const;
